import React, { useState, useEffect, useRef } from "react";
import { JSONEditor } from "vanilla-jsoneditor";
import "./JsonViewerInstanceTemplates.css";

const JsonViewerInstanceTemplates = ({ content = {}, handleUpdate, contentInit, hiddenStaticFields }) => {
  const refContainer = useRef(null);
  const refEditor = useRef(null);

  const [data, setData] = useState({});
  const [ready, setReady] = useState(false);

  const customRenderMenu = (items, context) => {
    return items.filter((item) => {
      if (
        item.type === "button" &&
        (item.text === "text" || item.text === "table" || item.text === "tree")
      ) {
        return false;
      }

      if (
        item.type === "button" &&
        (item.title === "Transform contents (filter, sort, project)" ||
          item.title === "Undo (Ctrl+Z)" ||
          item.title === "Redo (Ctrl+Shift+Z)" ||
          item.title === "Sort")
      ) {
        return false;
      }

      return true;
    });
  };


  useEffect(() => {
      try {
        const parsedConfiguration = JSON.parse(content);
        hiddenStaticFields.forEach(f => {
          delete parsedConfiguration.static[f]
        })
        delete parsedConfiguration.static.vm_configuration
        delete parsedConfiguration.static.terraform
        delete parsedConfiguration.static.seb_configuration
        setData(parsedConfiguration);
        if (!ready){
          refEditor.current.set({json: parsedConfiguration});
          setReady(true);
        }
      } catch (error) {
        console.error("Failed to parse JSON");
      }
  }, [content]);

  useEffect(() => {
    try {
      if (ready){
        const parsedConfiguration = JSON.parse(content);
        hiddenStaticFields.forEach(f => {
          delete parsedConfiguration.static[f]
        })
        delete parsedConfiguration.static.vm_configuration
        delete parsedConfiguration.static.terraform
        delete parsedConfiguration.static.seb_configuration
        setData(parsedConfiguration);
        refEditor.current.set({json: parsedConfiguration});
      }
    } catch (error) {
      console.error("Failed to parse JSON");
    }
  }, [contentInit]);


  function handleChange(json) {
      setData(json);
      handleUpdate(JSON.stringify(json));
  }

  useEffect(() => {
    refEditor.current = new JSONEditor({
      target: refContainer.current,
      props: {
        content: { json: {} },
        onChange: (updatedJson) => {
          if (handleUpdate) {
            handleChange(updatedJson.json);
          }
        },
        onRenderMenu: customRenderMenu,
      },
    });

    return () => {
      if (refEditor.current) {
        refEditor.current.destroy();
        refEditor.current = null;
      }
    };
  }, []);

  return <div ref={refContainer} />;
};

export default JsonViewerInstanceTemplates;
